module.exports = __webpack_public_path__ + "static/media/master-card.feb4ce10.svg";